import { THeaders } from '../../../types/request';
import {
  fetchCheckPaymentByProvider,
  IMappers,
} from '../../../repositories/billing-payments/v1/check-payment-by-provider';
import { IGetPaymentStatusParams, IPaymentStatus } from './types';
import { mapResponse200, mapResponse400 } from './utils';
import { EPaymentStatus } from '../../../types/reducers/depositAccount';

export const getPaymentStatus = async (params: IGetPaymentStatusParams): Promise<IPaymentStatus> => {
  const { httpApi, paymentId, provider } = params;

  const parameters = { externalPaymentId: paymentId, paymentProvider: provider };

  const mappers: IMappers<IPaymentStatus, IPaymentStatus> = {
    200: mapResponse200,
    400: mapResponse400,
  };

  const headers: THeaders = [['Content-Type', 'application/json']];

  const config = {
    requestConfig: {
      headers,
    },
  };

  try {
    const result = await fetchCheckPaymentByProvider({ httpApi, parameters, config, mappers });

    return result as IPaymentStatus;
  } catch (_) {
    return { status: EPaymentStatus.Pending, message: null };
  }
};
